import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { JobsRequestModel, jobsResponseModel, jobsStaffDdlResponseModel, jobstaskstaffDdlResponseModel, userprofileDdlResponseModel } from 'src/app/collaboration/components/jobs/components/models/jobs';
import { collaborationDdlService } from 'src/app/collaboration/components/jobs/components/services/ddl.service';
import { JobsService } from 'src/app/collaboration/components/jobs/components/services/jobs.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { LayoutService } from '../../services/layout.service';
import { clientDdlResponseModel } from 'src/app/interactions/models/clients';
import { DdlService } from 'src/app/interactions/services/ddl.service';
import { OrganizationSettingsService } from 'src/app/organization/services/organization-settings.service';
import { formMode } from 'src/app/shared/enums';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmService } from 'src/app/shared/services/confirm.service';
import { TimesheetLockService } from 'src/app/collaboration/components/timesheet-lock/components/timesheet-lock.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-job-timesheet',
  templateUrl: './job-timesheet.component.html',
})

export class JobTimesheetComponent extends BaseComponent implements OnInit {
  @Input() triggerApi!: boolean;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('calendar') calendar: any;
  current_page = this.storage_service.getPage();
  items_per_page = this.storage_service.getLimit();
  form_mode = formMode.Create;
  startDate: any = new Date();
  dateFormat: string = '';
  jobs_timesheet_form: FormGroup | any;
  job_timesheet_custom_fields_form: FormGroup | any;
  error_message: any
  selectedStartDate: any = new Date();
  user_list: any = [];
  jobs_list: any;
  job_task_list: any;
  raw_task_list: any;
  job_id: string;
  job_type_request: JobsRequestModel;
  client_list: any;
  billable_rate: any = 0.00;
  base_rate: any = 0.00;
  rate_source_list: any;
  disabledDates: Date[] = [];

  custom_fields: any = [];
  customFieldTextList: any = [];
  customTextList: any = [];
  customFieldParaList: any = [];
  customParaList: any = [];
  customFieldDateList: any = [];
  customDateList: any = [];
  customFieldNumberList: any = [];
  customNumberList: any = [];
  customFieldWebsiteList: any = [];
  customWebsiteList: any = [];
  customFieldCheckboxList: any = [];
  customCheckboxList: any = [];
  customFieldDropList: any = [];
  customDropList: any[] = [];
  customFieldRadioList: any = [];
  customRadioList: any = [];
  editCustomFieldList: any = [];
  timesheet_id: any;
  label: boolean = true
  client_id: any
  client_name: any
  job_task_id: any;
  minSelectableDate: Date;
  isResetting: boolean = false;
  job_task_name: string;
  job_name: string;
  url: any
  timesheet_details: any
  public isFormDirty: boolean = false

  constructor(
    public shared_service: SharedService,
    public jobs_service: JobsService,
    public layoutService: LayoutService,
    public translate_service: TranslationService,
    public common_service: CommonService,
    private fb: FormBuilder,
    private router: Router,
    private ddl_service: DdlService,
    private spinner_service: SpinnerService,
    private toaster_service: ToasterService,
    private confirm_service: ConfirmService,
    private storage_service: StorageService,
    private organization_service: OrganizationSettingsService,
    private collaborationddl_service: collaborationDdlService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private time_lock_service: TimesheetLockService,
    public renderer: Renderer2
  ) {
    super();
    this.jobs_timesheet_form = this.fb.group({
      client_id: [null, Validators.required],
      staff_id: [null, Validators.required],
      job_id: [null, Validators.required],
      job_task_id: [null, Validators.required],
      estimated_time: [
        this.common_service.getDefaultValue(),
        [Validators.required, this.common_service.timeFormatValidator.bind(this.common_service)]
      ],
      date: [this.selectedStartDate],
      notes: [''],
      is_billable: [true],
      rate_source_id: [null, Validators.required],
      base_rate: [''],
      billable_rate: [''],
    });

    this.job_timesheet_custom_fields_form = this.fb.group({
      customFieldText: [null],
      customFieldParagraph: [null],
      customFieldDate: [null],
      customFieldNumber: [null],
      customFieldLink: [null],
      customFieldCheckbox: [null],
      customFieldList: [null],
      customFieldRadio: [null]
    });

    if (this.config.data) {
      this.label = this.config.data.label
      this.job_id = this.config.data.job_id;
      this.form_mode = this.config.data.form_mode
      this.timesheet_id = this.config.data.timesheet_id
      this.client_id = this.config.data.client_id
      this.client_name = this.config.data.client_name
      this.job_task_id = this.config.data.job_task_id
      this.url = this.config.data.url
    }
  }


  ngOnInit() {
    this.dateFormat = this.shared_service.date_format_input_code;
    this.loadStaffDdl();
    this.loadCustomeFiled();
    this.loadClients();
    this.loadRateSourceDdl();
    if (this.formMode.Edit === this.form_mode) {
      this.gettimesheetDetails();
    }

    this.jobs_timesheet_form.get('rate_source_id').disable();
    if (!this.label) {
      const currentUrl = this.router.url;
      if (currentUrl.includes('clients')) {
        this.jobs_timesheet_form.get('client_id').disable();
      } else if (currentUrl.includes('jobs')) {
        this.jobs_timesheet_form.get('job_id').disable();
        this.jobs_timesheet_form.get('client_id').disable();
      }
      if (currentUrl.includes('job-task-info')) {
        this.jobs_timesheet_form.get('job_task_id').disable();
      }
    } else {
      this.jobs_timesheet_form.get('client_id').enable();
    }
    this.jobs_timesheet_form.get('job_id').setValue(this.job_id);
    this.jobs_timesheet_form.valueChanges.subscribe(() => {
      if (this.jobs_timesheet_form.dirty) {
        this.isFormDirty = true;
      } else {
        this.isFormDirty = false;
      }
    });
  }

  adjustDateRange() {
    if (this.shared_service.wip_lock_date && this.shared_service.is_wip_lock_date) {
      this.minSelectableDate = new Date(this.shared_service.wip_lock_date);
      const lockDate = new Date(this.shared_service.wip_lock_date);
      this.disabledDates = [];
      this.disabledDates.push(lockDate);
    }
  }

  adjustCalendarWithRetry(attempts = 0) {
    const maxAttempts = 5;
    const datepicker = document.querySelector('.p-datepicker');

    if (datepicker && this.label) {
      this.renderer.setStyle(datepicker, 'left', '-22px');
    } else if (attempts < maxAttempts) {
      setTimeout(() => this.adjustCalendarWithRetry(attempts + 1), 100);
    }
  }

  isRestrictedDate(date: any): boolean {
    if (!this.shared_service.wip_lock_date) return false;

    const currentDate = new Date(date.year, date.month, date.day);
    // currentDate.setDate(currentDate.getDate() + 1);
    const lockDate = new Date(this.shared_service.wip_lock_date);

    return currentDate <= lockDate;

  }

  loadClients() {
    const pagination: any = {
      page: this.current_page,
      limit: this.storage_service.getLimit(true)
    }

    this.ddl_service.getClientDdl(pagination).subscribe({
      next: (response: clientDdlResponseModel) => {
        if (response.result === 1) {
          this.client_list = response.data;
          this.jobs_timesheet_form.get('client_id').setValue(this.client_id);
          if (!this.label) {
            this.appendArchivedClient(this.client_id, this.client_name);
          }
          this.ClientChanged();
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });
  }

  loadRateSourceDdl() {
    const pagination: any = {
      page: this.current_page,
      limit: this.storage_service.getLimit(true)
    }

    this.ddl_service.getRateSourceDdl(pagination).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          this.rate_source_list = response.data;
          this.jobs_timesheet_form["submitted"] = false;
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });
  }

  onChangeJob(event: any, value?: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      let job_id = event?.value || event;
      this.jobs_service.jobsTaskDDl(job_id).subscribe({
        next: (response: any) => {
          if (response.result == 1) {
            this.raw_task_list = response.data
            this.job_task_list = this.raw_task_list.map((task: { task_name: any; label: any; phase_name: any }) => ({
              ...task,
              display_name: task.label
                ? `${task.task_name} - ${task.phase_name} (${task.label})`
                : `${task.task_name} - ${task.phase_name}`
            }));
            this.jobs_timesheet_form.patchValue({
              job_task_id: this.timesheet_details?.job_task_id,
            })
            this.appendArchivedNewTask(this.job_task_id, this.job_task_name);
            if (this.url?.includes('job-task-info')) {
              this.jobs_timesheet_form.get('job_task_id').setValue(this.job_task_id);
              this.taskStaffChanged()
            }
            if (value) {
              this.rateChange();
            }
            resolve();
          } else if (response.result == 0) {
            if (response.error.message) {
              this.toaster_service.showError(response.error.message[0]);
            }
            reject(response.error);
          } else {
            this.toaster_service.showError(response.stackTrace);
            reject(response.stackTrace);
          }
        },
        error: (error: any) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
          reject(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    });
  }

  taskStaffChanged() {
    const page = {
      page: this.current_page,
      limit: this.items_per_page
    }

    this.collaborationddl_service.getTaskStaffDdl(this.job_id, page, this.job_task_id).subscribe({
      next: (response: jobsStaffDdlResponseModel) => {
        if (response.result === 1) {
          this.user_list = response.data;
          const staff_id = this.storage_service.getUserId();
          this.jobs_timesheet_form.get('staff_id').setValue(staff_id);
          const data = {
            value: this.jobs_timesheet_form.get('job_task_id').value
          }
          this.rateChange(data);
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => { },
      complete: () => { }
    });
  }

  gettimesheetDetails() {
    this.jobs_service.get_timesheet(this.timesheet_id).subscribe({
      next: async (response: jobsResponseModel) => {
        if (response.result == 1) {
          this.timesheet_details = response.data;
          this.job_id = response?.data?.job_id;
          this.job_name = response?.data?.job_name;
          this.job_task_id = response?.data?.job_task_id;
          this.job_task_name = response?.data?.task_name;

          this.jobs_timesheet_form.patchValue({
            //job_task_id: response.data.job_task_id,
            staff_id: response.data.staff_id,
            date: new Date(response.data.date),
            notes: response.data.notes,
            is_billable: response.data.is_billable,
            rate_source_id: response.data.rate_source_id,
            rate: response.data.rate,
            job_id: response.data.job_id
          });
          this.ratedropChange();
          if (this.jobs_timesheet_form.get('rate_source_id').value !== 1) {
            this.jobs_timesheet_form.get('base_rate').disable();
            this.jobs_timesheet_form.get('billable_rate').disable();
          } else {
            this.jobs_timesheet_form.get('base_rate').enable();
            this.jobs_timesheet_form.get('billable_rate').enable();
          }
          if (this.jobs_timesheet_form.get('rate_source_id').value !== 1) {
            this.billable_rate = response.data.billable_rate;
            this.base_rate = response.data.base_rate
          } else {
            this.jobs_timesheet_form.patchValue({
              billable_rate: response.data.billable_rate,
              base_rate: response.data.base_rate
            })
          }
          if (this.shared_service.timesheet_format === '1') {
            this.jobs_timesheet_form.patchValue({
              estimated_time: response.data.estimated_time,
            })
          } else {
            const total_decimal = response.data.total_decimal
            this.jobs_timesheet_form.patchValue({
              estimated_time: parseInt(total_decimal).toFixed(2)
            })
          }
          if (response.data.customfields.length) {
            this.editCustomFieldList = response.data.customfields;
          }

        } else if (response.result == 0) {
          if (response.error.message) {
            this.toaster_service.showError(response.error.message[0])
          }
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.spinner_service.hide();
        this.toaster_service.showError(error);
      },
      complete: () => {
        this.spinner_service.hide();
      }
    });
  }

  onSave() {
    this.jobs_timesheet_form["submitted"] = true;
    if (!this.jobs_timesheet_form.valid) {
      this.findFirstInvalidControl();
      this.spinner_service.hide();
      return;
    }

    this.job_timesheet_custom_fields_form["submitted"] = true;
    if (!this.job_timesheet_custom_fields_form.valid) {
      this.findFirstInvalidControl();
      return;
    }
    this.job_type_request = this.jobs_timesheet_form.getRawValue();

    if (this.jobs_timesheet_form.get('rate_source_id').value !== 1) {
      this.job_type_request.billable_rate = this.billable_rate;
      this.job_type_request.base_rate = this.base_rate;
    } else {
      this.job_type_request.billable_rate = this.jobs_timesheet_form.get('billable_rate').value;
      this.job_type_request.base_rate = this.jobs_timesheet_form.get('base_rate').value;
    }

    if (this.jobs_timesheet_form.get('rate_source_id').value == 0) {
      this.toaster_service.showWarn('Check Rate Source');
      return;
    }

    this.jobs_timesheet_form.value.date = this.job_type_request.date = this.shared_service.formatDateToDB(this.jobs_timesheet_form.value.date);
    this.job_type_request.is_weekly = false;
    if (this.jobs_timesheet_form.get('estimated_time').value == "0.0" || this.jobs_timesheet_form.get('estimated_time').value == "00:00") {
      this.error_message = 'This field is required'
      this.jobs_timesheet_form.get('estimated_time')?.setErrors({ incorrect: true });
      return;
    }
    this.spinner_service.show();

    if (this.form_mode === formMode.Create) {
      this.jobs_service.addtimesheet(this.job_type_request).subscribe({
        next: (response: jobsResponseModel) => {
          if (response.result == 1) {
            this.jobs_timesheet_form.markAsPristine();
            if (this.jobs_timesheet_form.dirty) {
              this.isFormDirty = true;
            } else {
              this.isFormDirty = false;
            }
            this.timesheet_id = response.data.timesheet_id
            let custom = [...this.customTextList, ...this.customFieldTextList, ...this.customParaList, ...this.customDateList, ...this.customNumberList, ...this.customWebsiteList, ...this.customCheckboxList, ...this.customDropList, ...this.customRadioList]
            if (custom.length > 0) {
              this.timesheetCustomFieldCreate();
            } else {
              this.toaster_service.showSuccess(this.translate_service.getText('message_459'));
              this.onCancel(response.data);
            }
          } else if (response.result == 0) {
            if (response.error.job_task_id) {
              this.error_message = response.error.job_task_id[0];
              this.jobs_timesheet_form.get('job_task_id')?.setErrors({ incorrect: true });
            } else if (response.error.estimated_time) {
              this.error_message = response.error.estimated_time[0];
              this.jobs_timesheet_form.get('estimated_time')?.setErrors({ incorrect: true });
            } else if (response.error.staff_id) {
              this.error_message = response.error.staff_id[0];
              this.jobs_timesheet_form.get('staff_id')?.setErrors({ incorrect: true });
            } else if (response.error.date) {
              this.error_message = response.error.date[0];
              this.jobs_timesheet_form.get('date')?.setErrors({ incorrect: true });
            } else if (response.error.client_id) {
              this.error_message = response.error.client_id[0];
              this.jobs_timesheet_form.get('client_id')?.setErrors({ incorrect: true });
            } else if (response.error.notes) {
              this.error_message = response.error.notes[0];
              this.jobs_timesheet_form.get('notes')?.setErrors({ incorrect: true });
            } else {
              this.error_message = response.error.message[0];
              this.toaster_service.showError(response.error.message[0]);
            }
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    } else {
      this.jobs_service.updatetimesheet(this.timesheet_id, this.job_type_request).subscribe({
        next: (response: jobsResponseModel) => {
          if (response.result == 1) {
            this.jobs_timesheet_form.markAsPristine();
            if (this.jobs_timesheet_form.dirty) {
              this.isFormDirty = true;
            } else {
              this.isFormDirty = false;
            }
            this.timesheet_id = response.data.timesheet_id
            let custom = [...this.customTextList, ...this.customFieldTextList, ...this.customParaList, ...this.customDateList, ...this.customNumberList, ...this.customWebsiteList, ...this.customCheckboxList, ...this.customDropList, ...this.customRadioList]
            if (custom.length > 0) {
              this.timesheetCustomFieldCreate();
            } else {
              this.toaster_service.showSuccess(this.translate_service.getText('message_459'));
              this.onCancel(response.data);
            }
          } else if (response.result == 0) {
            if (response.error.task_id) {
              this.error_message = response.error.task_id[0];
              this.jobs_timesheet_form.get('task_id')?.setErrors({ incorrect: true });
            } if (response.error.estimated_time) {
              this.error_message = response.error.estimated_time[0];
              this.jobs_timesheet_form.get('estimated_time')?.setErrors({ incorrect: true });
            } if (response.error.staff_id) {
              this.error_message = response.error.staff_id[0];
              this.jobs_timesheet_form.get('staff_id')?.setErrors({ incorrect: true });
            } if (response.error.date) {
              this.error_message = response.error.date[0];
              this.jobs_timesheet_form.get('date')?.setErrors({ incorrect: true });
            } if (response.error.notes) {
              this.error_message = response.error.notes[0];
              this.jobs_timesheet_form.get('notes')?.setErrors({ incorrect: true });
            } if (response.error.client_id) {
              this.error_message = response.error.client_id[0];
              this.jobs_timesheet_form.get('client_id')?.setErrors({ incorrect: true });
            } if (response.error.message) {
              this.toaster_service.showError(response.error.message[0])
            }
            setTimeout(() => this.findFirstInvalidControl(), 0);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    }
  }

  onCancel(data: any) {
    const close = () => {
      if (this.label) {
        this.isResetting = true;
        this.jobs_timesheet_form.reset();
        this.jobs_timesheet_form["submitted"] = false;
        this.onClose.emit(true);
      } else {
        this.ref.close(data);
      }
    };

    if (this.isFormDirty) {
      this.confirm_service
        .showConfirmation(this.translate_service.getText('info_40'))
        .then((result) => {
          if (result) close();
        });
    } else {
      close();
    }
  }


  ClientChanged(value?: boolean) {
    if (this.isResetting) return
    this.jobs_service.clientJob(this.jobs_timesheet_form.get('client_id').value).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          this.jobs_list = response.data;

          this.appendArchivedJob(this.job_id, this.job_name);

          if (this.label) {
            this.jobs_timesheet_form.get('job_id').setValue(this.job_id);
          }
          this.onChangeJob(this.jobs_timesheet_form.get('job_id').value);
          if (value) {
            this.rateChange();
          }
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });
  }

  loadStaffDdl() {
    const page = {
      page: this.current_page,
      limit: this.items_per_page
    }
    if (this.label || this.url.includes('clients')) {
      this.collaborationddl_service.getstaff_ddl(page).subscribe({
        next: (response: userprofileDdlResponseModel) => {
          if (response.result === 1) {
            this.user_list = response.data;
            const staff_id = this.storage_service.getUserId();
            this.jobs_timesheet_form.get('staff_id').setValue(staff_id);
          } else if (response.result === 0) {
            this.toaster_service.showError(response.error.message[0]);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => { },
        complete: () => { }
      });
    } else if (this.url.includes('timesheets')) {
      this.collaborationddl_service.getStaffDdl(this.job_id, page).subscribe({
        next: (response: jobsStaffDdlResponseModel) => {
          if (response.result === 1) {
            this.user_list = response.data;
            const staff_id = this.storage_service.getUserId();
            this.jobs_timesheet_form.get('staff_id').setValue(staff_id)
          } else if (response.result === 0) {
            this.toaster_service.showError(response.error.message[0]);
          } else {
            this.toaster_service.showError(response.stackTrace);
          }
        },
        error: (error: any) => { },
        complete: () => { }
      });
    }
  }

  ratedropChange() {
    if (!this.jobs_timesheet_form.get('job_task_id').value || !this.jobs_timesheet_form.get('staff_id').value || !this.jobs_timesheet_form.get('client_id').value ||
      !this.jobs_timesheet_form.get('job_id').value) {
      this.jobs_timesheet_form.get('rate_source_id').disable();
    } else {
      this.jobs_timesheet_form.get('rate_source_id').enable();
    }
  }

  rateChange(event?: any, rate?: any) {
    if (event?.value && !rate) {
      const billable = this.job_task_list.filter((task: any) => task.job_task_id == event.value)[0].is_billable;
      this.jobs_timesheet_form.patchValue({
        is_billable: billable
      })
    }
    if (!this.jobs_timesheet_form.get('job_task_id').value || !this.jobs_timesheet_form.get('staff_id').value || !this.jobs_timesheet_form.get('client_id').value ||
      !this.jobs_timesheet_form.get('job_id').value) {
      this.jobs_timesheet_form.get('rate_source_id').disable();
    } else {
      this.jobs_timesheet_form.get('rate_source_id').enable();
    }

    if (this.jobs_timesheet_form.get('rate_source_id').value !== 1) {
      this.jobs_timesheet_form.get('base_rate').disable();
      this.jobs_timesheet_form.get('billable_rate').disable();
    } else {
      this.jobs_timesheet_form.get('base_rate').enable();
      this.jobs_timesheet_form.get('billable_rate').enable();
      return;
    }

    const data = {
      client_id: this.jobs_timesheet_form.get('client_id').value || '',
      job_id: this.jobs_timesheet_form.get('job_id').value || '',
      staff_id: this.jobs_timesheet_form.get('staff_id').value || '',
      task_id: this.jobs_timesheet_form.get('job_task_id').value || '',
      rate_source_id: rate === true ? this.jobs_timesheet_form.get('rate_source_id').value : '',
    }

    this.jobs_service.rateSource(data).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          if (response.data.rate_source_id !== 0) {
            this.billable_rate = response.data.billable_rate
            this.base_rate = response.data.base_rate
            this.jobs_timesheet_form.get('rate_source_id')?.setValue(response.data.rate_source_id);
          } else {
            this.billable_rate = response.data.billable_rate
            this.base_rate = response.data.base_rate
          }
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message?.[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => {
        //this.lockDateCheck();
      }
    });
  }

  lockDateCheck() {
    if (this.isResetting) return
    this.time_lock_service.timesheet_lock_get(this.jobs_timesheet_form.get('staff_id').value).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          if (response.data[0]) {
            this.disabledDates = response.data[0].Date.map((dateStr: string | number | Date) => new Date(dateStr));
            const disable_dates = response.data[0].Date.map((dateStr: string | number | Date) => {
              const date = new Date(dateStr);
              return date.toDateString();
            });
            const selectDate = this.selectedStartDate.toDateString()
            if (disable_dates.some((date: any) => date === selectDate)) {
              this.selectedStartDate = null;
            }
          } else {
            this.disabledDates = []
          }
        } else if (response.result === 0) {
          this.toaster_service.showError(response.error.message?.[0]);
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => {
      }
    });
  }

  onDelete() {
    if (this.timesheet_details?.is_task_completed) {
      this.confirm_service.showWarning('The timesheet cannot be deleted because there are completed tasks.').then((result) => {
        if (result.valueOf()) { }
      });
      return;
    }
    if (this.timesheet_details?.is_invoiced) {
      this.confirm_service.showWarning('The timesheet cannot be deleted because there are invoiced').then((result) => {
        if (result.valueOf()) { }
      });
      return;
    }
    this.confirm_service.showConfirmation(this.translate_service.getText('message_487')).then((result) => {
      if (result) {
        this.spinner_service.show();
        const data = {
          is_deleted: true
        }
        this.jobs_service.deleteTimesheet(this.timesheet_id, data).subscribe({
          next: (response: any) => {
            this.spinner_service.hide();
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translate_service.getText('message_486'));
              this.onCancel(response.data)
            } else if (response.result == 0) {
              if (response.error.message) {
                this.toaster_service.showError(response.error.message[0])
              }
            }
          },
          error: (error: any) => {
            this.spinner_service.hide();
            this.toaster_service.showError(error);
          },
          complete: () => {
            this.spinner_service.hide();
          }
        });
      } else {
        console.log('no');
      }
    });
  }

  loadCustomeFiled() {
    const custom: any = {
      usage: 9,
      page: this.current_page,
      limit: this.storage_service.getLimit(true)
    }
    this.organization_service.getCustomFiled(custom).subscribe({
      next: ((response: any) => {
        if (response.result === 1) {
          this.custom_fields = response.data;
        } else if (response.result === -1) {
          this.toaster_service.showError(response.stackTrace);
        } else {
          this.toaster_service.showError(response.error.message[0]);
        }
      }),
      error: ((error: any) => {
        this.spinner_service.hide();
        this.toaster_service.showError(error);
      }),
      complete: () => {
        this.spinner_service.hide();
      }
    })
  }

  timesheetCustomFieldCreate() {
    let customFieldsVal: any[] = [];

    if (this.customTextList !== null) {
      this.customTextList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldsText = [...new Map(this.customTextList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldsText]
      } else {
        customFieldsVal = customFieldsText
      }
    }

    if (this.customParaList !== null) {
      this.customParaList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldsPara = [...new Map(this.customParaList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldsPara]
      } else {
        customFieldsVal = customFieldsPara;
      }
    }

    if (this.customDateList !== null) {
      this.customDateList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldsDate = [...new Map(this.customDateList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldsDate]
      } else {
        customFieldsVal = customFieldsDate;
      }
    }

    if (this.customNumberList !== null) {
      this.customNumberList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldsNumber = [...new Map(this.customNumberList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldsNumber]
      } else {
        customFieldsVal = customFieldsNumber;
      }
    }

    if (this.customWebsiteList !== null) {
      this.customWebsiteList.forEach((item: { [x: string]: any; }) => {
        for (const key in item) {
          if (item['required'] == false) {

          }
          if (item[key] === undefined || item[key] === null) {
            item[key] = '';
          }
        }
      });
      let customFieldLink = [...new Map(this.customWebsiteList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldLink]
      } else {
        customFieldsVal = customFieldLink;
      }
    }

    if (this.customCheckboxList !== null) {
      this.customCheckboxList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldCheckbox = [...new Map(this.customCheckboxList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldCheckbox]
      } else {
        customFieldsVal = customFieldCheckbox;
      }
    }

    if (this.customDropList !== null) {
      this.customDropList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldDrop = [...new Map(this.customDropList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldsVal.length) {
        customFieldsVal = [...customFieldsVal, ...customFieldDrop]
      } else {
        customFieldsVal = customFieldDrop;
      }
    }

    if (this.customRadioList !== null) {
      this.customRadioList.forEach((item: { [x: string]: any; }) => {
        if (item['required'] == false) {
          for (const key in item) {
            if (item[key] === undefined || item[key] === null) {
              item[key] = '';
            }
          }
        }
      });
      let customFieldRadio = [...new Map(this.customRadioList.map((m: { id: any; }) => [m.id, m])).values()];
      if (customFieldRadio) {
        if (customFieldsVal.length) {
          customFieldsVal = [...customFieldsVal, ...customFieldRadio];
        } else {
          customFieldsVal = customFieldRadio;
        }
      }
    }

    for (const field of customFieldsVal) {
      if (field.required && (field.value === '' || field.value === undefined)) {
        console.log('Required field is missing:', field);
        return;
      }
    }

    if (this.form_mode === formMode.Create) {
      const postdata = {
        timesheet_id: this.timesheet_id,
        customfields: customFieldsVal
      }
      this.jobs_service.createTimesheetCustomField(postdata).subscribe({
        next: (response) => {
          if (response.result === 1) {
            this.toaster_service.showSuccess(this.translate_service.getText('message_459'));
            this.onCancel(response.data);
          } else if (response.result === -1) {
            this.toaster_service.showError(response.stackTrace);
          }
          else {
            this.toaster_service.showError(response.error.value[0]);
          }
        },
        error: (error: any) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      })
    } else {
      const postdata = {
        customfields: customFieldsVal
      }
      this.jobs_service.updateTimesheetCustomField(postdata, this.timesheet_id).subscribe({
        next: (response) => {
          if (response.result === 1) {
            this.toaster_service.showSuccess(this.translate_service.getText('message_423'));
            this.onCancel(response.data)
          } else if (response.result === -1) {
            this.toaster_service.showError(response.stackTrace);
          }
          else {
            this.toaster_service.showError(response.error.value[0]);
          }
        },
        error: (error: any) => {
          this.spinner_service.hide();
          this.toaster_service.showError(error);
        },
        complete: () => {
          this.spinner_service.hide();
        }
      });
    }
  }

  onIsRequiredChange($event: any, id: any) {
    if ($event.type_id === this.customFields.Text && $event.id === id) {
      if ($event.required === true) {
        const textField = this.job_timesheet_custom_fields_form.get('customFieldText');
        this.setAndUpdateValidators(textField, Validators.required);
      }
    } else if ($event.type_id === this.customFields.MultilineText && $event.id === id) {
      if ($event.required === true) {
        const paragraphText = this.job_timesheet_custom_fields_form.get('customFieldParagraph');
        this.setAndUpdateValidators(paragraphText, Validators.required);
      }
    } else if ($event.type_id === this.customFields.Date && $event.id === id) {
      if ($event.required === true) {
        const dateField = this.job_timesheet_custom_fields_form.get('customFieldDate');
        this.setAndUpdateValidators(dateField, Validators.required);
      }
    } else if ($event.type_id === this.customFields.Link && $event.id === id) {
      if ($event.required === true) {
        const numberField = this.job_timesheet_custom_fields_form.get('customFieldLink');
        this.setAndUpdateValidators(numberField, Validators.required);
      }
    } else if ($event.type_id === this.customFields.Number && $event.id === id) {
      if ($event.required === true) {
        const numberField = this.job_timesheet_custom_fields_form.get('customFieldNumber');
        this.setAndUpdateValidators(numberField, Validators.required);
      }
    } else if ($event.type_id === this.customFields.SingleCheckBox && $event.id === id) {
      if ($event.required === true) {
        const checkbox = this.job_timesheet_custom_fields_form.get('customFieldCheckbox');
        this.setAndUpdateValidators(checkbox, Validators.required);
      }
    } else if ($event.type_id === this.customFields.List && $event.id === id) {
      if ($event.required === true) {
        const checkbox = this.job_timesheet_custom_fields_form.get('customFieldList');
        this.setAndUpdateValidators(checkbox, Validators.required);
      }
    } else if ($event.type_id === this.customFields.RadioButton && $event.id === id) {
      if ($event.required === true) {
        const checkbox = this.job_timesheet_custom_fields_form.get('customFieldRadio');
        this.setAndUpdateValidators(checkbox, Validators.required);
      }
    }
  }

  onTextChange(event: any) {
    const existingItemIndex = this.customFieldTextList.findIndex((item: { id: any; }) => item.id === event.id);

    if (event.value.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldTextList.splice(existingItemIndex, 1);
        this.customTextList[existingItemIndex].value = event.value;
      } else {
        this.customTextList.push(event);
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldTextList[existingItemIndex] = event;
        this.customTextList[existingItemIndex] = event;
      } else {
        this.customFieldTextList.push(event);
        this.customTextList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldText: this.customFieldTextList
    });

    this.job_timesheet_custom_fields_form.get('customFieldText').updateValueAndValidity();
  }

  onParaChange(event: any) {
    const existingItemIndex = this.customFieldParaList.findIndex((item: { id: any; }) => item.id === event.id);

    if (event.value.trim() === '') {

      if (existingItemIndex !== -1) {
        this.customFieldParaList.splice(existingItemIndex, 1);
        this.customParaList[existingItemIndex].value = event.value;
      } else {
        this.customParaList.push(event);
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldParaList[existingItemIndex] = event;
        this.customParaList[existingItemIndex] = event;
      } else {
        this.customFieldParaList.push(event);
        this.customParaList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldParagraph: this.customFieldParaList
    });

    this.job_timesheet_custom_fields_form.get('customFieldParagraph').updateValueAndValidity();
  }

  onDateChange(event: any) {
    const existingItemIndex = this.customFieldDateList.findIndex((item: { id: any; }) => item.id === event.id);
    if (event.value.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldDateList.splice(existingItemIndex, 1);
        this.customDateList[existingItemIndex].value = event.value;
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldDateList[existingItemIndex] = event;
        this.customDateList[existingItemIndex] = event;
      } else {
        this.customFieldDateList.push(event);
        this.customDateList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldDate: this.customFieldDateList
    });

    this.job_timesheet_custom_fields_form.get('customFieldDate').updateValueAndValidity();
  }

  onWebsiteChange(event: any) {
    const existingItemIndex = this.customFieldWebsiteList.findIndex((item: { id: any; }) => item.id === event.id);

    if (event.value.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldWebsiteList.splice(existingItemIndex, 1);
        this.customWebsiteList[existingItemIndex].value = event.value;
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldWebsiteList[existingItemIndex] = event;
        this.customWebsiteList[existingItemIndex] = event;
      } else {
        this.customFieldWebsiteList.push(event);
        this.customWebsiteList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldLink: this.customFieldWebsiteList
    });

    this.job_timesheet_custom_fields_form.get('customFieldLink').updateValueAndValidity();
  }

  onNumberChange(event: any) {
    const existingItemIndex = this.customFieldNumberList.findIndex((item: { id: any; }) => item.id === event.id);
    if (event.value.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldNumberList.splice(existingItemIndex, 1);
        this.customNumberList[existingItemIndex].value = event.value;
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldNumberList[existingItemIndex] = event;
        this.customNumberList[existingItemIndex] = event;
      } else {
        this.customFieldNumberList.push(event);
        this.customNumberList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldNumber: this.customFieldNumberList
    });

    this.job_timesheet_custom_fields_form.get('customFieldNumber').updateValueAndValidity();
  }

  onCheckboxChange(event: any) {
    const existingItemIndex = this.customFieldCheckboxList.findIndex((item: { id: any; }) => item.id === event.id);
    if (event.value === false) {
      if (existingItemIndex !== -1) {
        this.customFieldCheckboxList.splice(existingItemIndex, 1);
        this.customCheckboxList[existingItemIndex].value = event.value;
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldCheckboxList[existingItemIndex] = event;
        this.customCheckboxList[existingItemIndex] = event;
      } else {
        this.customFieldCheckboxList.push(event);
        this.customCheckboxList.push(event);
      }
    }

    this.job_timesheet_custom_fields_form.patchValue({
      customFieldCheckbox: this.customFieldCheckboxList
    });

    this.job_timesheet_custom_fields_form.get('customFieldCheckbox').updateValueAndValidity();
  }

  onListChange(event: any) {
    const existingItemIndex = this.customFieldDropList.findIndex((item: { id: any; }) => item.id === event.id);

    if (event.value?.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldDropList.splice(existingItemIndex, 1);
        this.customDropList[existingItemIndex].value = event.value;
      } else {
        this.customDropList.push(event);
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldDropList[existingItemIndex] = event;
        this.customDropList[existingItemIndex] = event;
      } else {
        this.customFieldDropList.push(event);
        this.customDropList.push(event);
      }

      this.job_timesheet_custom_fields_form.patchValue({
        customFieldList: this.customFieldDropList
      });

      this.job_timesheet_custom_fields_form.get('customFieldList').updateValueAndValidity();
    }
  }

  onRadioChange(event: any) {
    const existingItemIndex = this.customFieldRadioList.findIndex((item: { id: any; }) => item.id === event.id);

    if (event.value?.trim() === '') {
      if (existingItemIndex !== -1) {
        this.customFieldRadioList.splice(existingItemIndex, 1);
        this.customRadioList[existingItemIndex].value = event.value;
      } else {
        this.customRadioList.push(event);
      }
    } else {
      if (existingItemIndex !== -1) {
        this.customFieldRadioList[existingItemIndex] = event;
        this.customRadioList[existingItemIndex] = event;
      } else {
        this.customFieldRadioList.push(event);
        this.customRadioList.push(event);
      }

      this.job_timesheet_custom_fields_form.patchValue({
        customFieldRadio: this.customFieldRadioList
      });

      this.job_timesheet_custom_fields_form.get('customFieldRadio').updateValueAndValidity();
    }
  }

  private findFirstInvalidControl(): void {
    const invalidControl = document.querySelector('.ng-invalid:not(form)') as HTMLElement;
    if (invalidControl) {
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalidControl.focus();
    }
  }

  appendArchivedClient(client_id: string, client_name: string) {
    const isExists = this.client_list.find((client: any) => client?.client_id === client_id);
    let clientDetail = {
      client_id: client_id,
      name: client_name
    }
    if (!isExists) {
      this.client_list.push(clientDetail);
    }
  }

  appendArchivedNewTask(id: string, name: string) {
    if (id && name) {
      const isExists = this.job_task_list.find((task: any) => task?.job_task_id === id);
      let taskDetail = {
        job_task_id: id,
        task_name: name
      }
      if (!isExists) {
        this.job_task_list.push(taskDetail);
      }
    }
  }

  appendArchivedJob(id: string, name: string) {
    if (id && name) {
      const isExists = this.jobs_list.find((task: any) => task?.job_task_id === id);
      let jobDetail = {
        job_id: id,
        name: name
      }
      if (!isExists) {
        this.jobs_list.push(jobDetail);
      }
    }
  }

  validateAndConvertTime(): void {
    this.common_service.validateAndConvertTime(this.jobs_timesheet_form.get('estimated_time'), 'timesheet');
  }

  confirmDiscardChanges(): Promise<boolean> {
    return this.confirm_service.showConfirmation(
      this.translate_service.getText('info_40')
    );
  }
}